import deepmerge from 'deepmerge';
import { isPlainObject } from './isPlainObject';

const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;

/**
 * Recursively merge two objects.
 * - By default, arrays are overwritten
 * - By default, only plain objects are merged
 *
 * More details: https://www.npmjs.com/package/deepmerge
 *
 * @param {object} x
 * @param {object} y
 * @param {object} options
 * @param {function} options.arrayMerge
 * @param {function} options.isMergeableObject
 * @param {function} options.customMerge
 */
export const deepMerge = (
	x,
	y,
	{
		arrayMerge = overwriteMerge,
		isMergeableObject = isPlainObject,
		customMerge,
	} = {},
) => deepmerge(x, y, { arrayMerge, isMergeableObject, customMerge });
